module.exports = __webpack_public_path__ + "static/media/cases_3d_06f.a1572dc5.jpg";